import { useState, useEffect, useCallback, useRef } from "react"
import styles from "./styles.module.scss"
import cn from "clsx"
import type { FC, HTMLAttributes } from "react"


interface FadeProps
extends HTMLAttributes<HTMLDivElement> {
  
}


export const Fade: FC<FadeProps> = ({ ...rest }) => {
  const [ isVisible, setVisibilityState ] = useState(false)
  const wrapperRef = useRef<HTMLDivElement>(null)
  const scrollHandler = useCallback(() => {
    const rect = wrapperRef.current.getBoundingClientRect()
    const { innerHeight } = window
    if (rect.top - innerHeight * 1.1 < 0) setVisibilityState(true)
  }, [])

  useEffect(() => {
    window.addEventListener('scroll', scrollHandler, { passive: true })
    return () => window.removeEventListener('scroll', scrollHandler)
  }, [scrollHandler])

  useEffect(() => {
    if (isVisible) window.removeEventListener('scroll', scrollHandler)
  }, [isVisible, scrollHandler])

  return (
    <div {...rest}
      className={cn(styles.fade, {[styles.visible]: isVisible })} 
      ref={wrapperRef} />
  )
}
